/**
 * A wrapper to implement dynamic columns based on content width.
 */

import { useEffect, useRef, useState } from "react";

import "./Columnizer.scss";

const CLASSES: {
  [key: number]: string;
} = {
  1: "single",
  2: "double",
  3: "triple",
  4: "quadruple",
  5: "quintuple",
  6: "sextuple",
  7: "septuple",
  8: "octuple",
};

export const Columnizer = (props: {
  sizes: number[];
  children: React.ReactNode;
  className?: string;
}) => {
  const [columns, setColumns] = useState<number>(1);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onResize = () => {
      const width = ref.current?.clientWidth ?? 0;

      const matches = props.sizes.filter((size: number): boolean => {
        return width >= size;
      });

      const newCols = matches.length + 1;

      setColumns(newCols);
    };

    window.addEventListener("resize", onResize, false);

    onResize();

    return () => {
      window.removeEventListener("resize", onResize, false);
    };
  }, [props.sizes]);

  const classes = (): string => {
    const parts = ["columns"];

    parts.push(CLASSES[columns] ?? "single");

    if (props.className) {
      parts.push(props.className);
    }

    return parts.join(" ");
  };

  return (
    <div ref={ref} className={classes()}>
      {props.children}
    </div>
  );
};
